// Parses a user-typed decimal number, accepting both "." and "," as the
// decimal separator (Croatian/German keyboards and habits use the comma;
// a browser type="number" input rejects a comma outright, which is why
// these fields are plain text inputs with this validation instead).
//
// Returns null for "not entered" (blank/incomplete), NaN for "entered but
// not a valid number" - callers treat those two cases differently (blank
// is fine for an optional field, NaN is a validation error).
export function parseDecimal(value) {
  if (value === "" || value === null || value === undefined) {
    return null;
  }
  const normalized = String(value).trim().replace(",", ".");
  if (normalized === "" || normalized === "-" || normalized === ".") {
    return null;
  }
  if (!/^-?\d*\.?\d*$/.test(normalized)) {
    return NaN;
  }
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : NaN;
}

// Netto/brutto-aware derived total, shared by every price-entry form
// (warehouse items, services) so the formula lives in one place. In
// BRUTTO mode "price" is what the user typed (VAT-inclusive) and the
// derived value is netto; in NETTO mode it's the reverse. Returns null
// when either input is missing/invalid, so callers can treat that as
// "nothing to show yet" the same way they already do.
export function deriveTotalPrice(priceValue, pdvValue, priceEntryMode) {
  const price = parseDecimal(priceValue);
  const pdv = parseDecimal(pdvValue);
  if (price == null || Number.isNaN(price) || pdv == null || Number.isNaN(pdv)) {
    return null;
  }
  return priceEntryMode === "BRUTTO" ? price / (1 + pdv / 100) : price + (price * pdv) / 100;
}

export function decimalRules(t, { min, max } = {}) {
  return {
    validate: (value) => {
      if (value === "" || value == null) {
        return true;
      }
      const parsed = parseDecimal(value);
      if (Number.isNaN(parsed)) {
        return t("InvalidDecimalNumber");
      }
      if (min != null && parsed < min) {
        return t("MustBePositiveNumber");
      }
      if (max != null && parsed > max) {
        return t("MustBeBetween0And100");
      }
      return true;
    },
  };
}
